import { Component } from '@angular/core';
import { ComingSoonComponent } from '../coming-soon.component';

@Component({
  selector: 'app-settings-coming-soon',
  standalone: true,
  imports: [ComingSoonComponent],
  template: `<app-coming-soon title="Settings" />`,
})
export class SettingsComingSoonComponent {}
